/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const mapContainerCss = css({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 32,
  [MediaQueries.lgAndUp]: {
    order: 2,
  },
});

export const mapBlockCss = css({
  maxHeight: 328,
  [MediaQueries.mdAndUp]: {
    maxHeight: 500,
  },

  '.zoom-in-control': {
    marginLeft: 16,
    marginTop: 16,
  },

  '.zoom-out-control': {
    marginLeft: 16,
  },
});

export const headingCss = css(typography.effra48, {
  fontWeight: fontWeights.medium,
  position: 'relative',
  color: colorsPalette.grey,
  marginBottom: 32,
  [MediaQueries.md]: {
    marginBottom: 21,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 16,
  },
});

export const addressCss = css(typography.effra18, {
  color: colorsPalette.grey,
  [MediaQueries.mdAndUp]: {
    display: 'inline',
    marginRight: 16,
  },
});

export const contentCss = css({
  width: '100%',
  [MediaQueries.md]: {
    width: '50%',
    display: 'inline-block',
    verticalAlign: 'top',
  },
  [MediaQueries.lgAndUp]: {
    width: '100%',
  },
});

export const contentBlockCss = css({
  marginTop: 28,
  [MediaQueries.mdAndUp]: {
    marginTop: 40,
  },
});

export const dataTitleCss = css(typography.effra18, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.grey,
  marginBottom: 16,
});

export const contentWrapperCss = css({
  marginBottom: 36,
});

export const dataContentTitleCss = css(typography.effra16, {
  marginBottom: 8,
  display: 'inline-block',
  color: colorsPalette.grey,
});

export const gettingThereTypeCss = css({
  margin: '0 8px 0 19px',
});

export const open247IconCss = css({
  marginRight: 10,
  verticalAlign: 'text-top',
});

export const dataContentValueCss = css(dataContentTitleCss, {
  color: colorsPalette.grey60,
  marign: 0,
});

export const containerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
});

export const nearPlaceMapRenderCss = css(typography.effra14, {
  transform: 'translate(-50%, -50%)',
  display: 'table',
  backgroundColor: colorsPalette.white,
  color: colorsPalette.grey,
  position: 'absolute',
  textAlign: 'center',
  padding: '2px 10px',
  borderRadius: '30px',
  width: 'fit-content',
  height: 'fit-content',
  whiteSpace: 'nowrap',
  top: 20,
  '&:before': {
    backgroundColor: colorsPalette.white,
    width: 20,
    height: 20,
    borderRadius: '50%',
    content: "''",
    position: 'absolute',
    left: '50%',
    marginLeft: '-10px',
    bottom: 30,
    border: `6px solid ${colorsPalette.red}`,
  },
});

export const locationPlaceCss = css(typography.effra18, {
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  display: 'table',
  fontWeight: fontWeights.medium,
  backgroundColor: colorsPalette.white,
  color: colorsPalette.grey,
  boxShadow: shadows.shadow40,
  textAlign: 'center',
  padding: '20px 30px',
  borderRadius: 2,
  width: 'fit-content',
  height: 'fit-content',
  whiteSpace: 'nowrap',
  top: '-80px',
  '&:before': {
    fontFamily: 'regus-icon-font',
    fontSize: 30,
    color: colorsPalette.grey,
    width: 25,
    height: 30,
    content: "'\\fea57'",
    left: '-13PX',
    top: 75,
    right: 0,
    position: 'absolute',
    marginLeft: '50%',
  },
  '&:after': {
    content: "''",
    position: 'absolute',
    right: '50%',
    marginRight: -6,
    bottom: -6,
    width: 12,
    height: 12,
    backgroundColor: colorsPalette.white,
    transform: 'rotate(45deg)',
  },
});

export const phoneNumberCss = css({
  marginBottom: 36,
  '.phone-container': {
    display: 'inline-flex',
  },
  '.phone-label': {
    ...typography.effra18,
    fontWeight: fontWeights.medium,
    marginBottom: 16,
    marginLeft: 0,
    order: -1,
    width: '100%',
  },
  '.phone-default-icon': {
    marginRight: 16,
  },
});

export const otherLocationsLinkCss = css(typography.effra12, {
  display: 'inline-block',
  marginTop: 13,
  textDecoration: 'none',
  [MediaQueries.mdAndUp]: {
    marginTop: 10,
  },
});

export const nearByLocationsCss = css({
  background: colorsPalette.teal,
  borderRadius: 2,
  color: colorsPalette.white,
  display: 'inline-block',
  marginRight: 12,
  padding: '4px 5px',
});

export const otherLocationsTextCss = css({
  color: colorsPalette.grey60,
  borderBottom: `1px solid ${colorsPalette.grey60}`,
  display: 'inline',
  textTransform: 'uppercase',
});

export const squaredotCSs = css({
  color: colorsPalette.grey20,
  margin: '0 8px',
  position: 'relative',
  bottom: 6,
});
